/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Win6_DInputs */

const en_wc_vs_win6_d = /** @type {(inputs: Wc_Vs_Win6_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A CLI, a JSON control channel and an MCP server expose all 422 commands to scripts and AI agents. No VBA required.`)
};

/**
* | output |
* | --- |
* | "A CLI, a JSON control channel and an MCP server expose all 422 commands to scripts and AI agents. No VBA required." |
*
* @param {Wc_Vs_Win6_DInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_win6_d = /** @type {((inputs?: Wc_Vs_Win6_DInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Win6_DInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_win6_d(inputs)
});
export { wc_vs_win6_d as "wc.vs.win6.d" }